import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', hover = true }) => {
  return (
    <div className={`ym-clean-card ${hover ? 'ym-clean-card-hover' : ''} p-6 ${className}`}>
      {children}
    </div>
  );
};
